module.exports = __webpack_public_path__ + "img/code-analyzer02.6e987355.jpg";